//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicHeader from "../Header";
import PublicFooter from "../Footer";
import Steps from "./Steps";
import ForWhom from "./ForWhom";
export default {
  meta: {
    title: "合作伙伴计划",
    meta: [{
      name: "description",
      content: "SalesFinder - 搜索有利可图的利基市场, 分析竞争对手的价格和销售额, 跟踪位置, 品牌和卖家的数据. 方便的市场分析可增加您的销售额!"
    }, {
      name: "viewport",
      content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
    }]
  },
  components: {
    PublicHeader,
    PublicFooter,
    Steps,
    ForWhom
  },
  methods: {
    onCtaClick() {
      if (this.$store.state.user.user) {
        this.$router.push({
          name: "ProfilePartner"
        });
      } else {
        this.$router.push({
          name: "Register",
          params: {
            backRoute: {
              name: "ProfilePartner"
            }
          }
        });
      }
    }
  }
};